export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Baby Blue-1.94b63c15.jpg";